import useUndoRedoListener from './useUndoRedoListener';

/**
 * Listens for undo and redo keyboard shortcuts and replays the recorded history back into the report store.
 *
 * @returns An empty div rendered purely to host the keyboard listener.
 */
const UndoState = () => {
  useUndoRedoListener();
  return <div />;
};

export default UndoState;
